import React, { useEffect, useContext, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { invoiceService } from "../../services/invoice.service";
import LogicContext from "../../Context/LogicContext";
import { SetInvoiceData, GetInvoiceData } from "../../store/invoiceAtom";
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import TableMenuCheckSelect from "../../helpers/TableMenuCheckSelect";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import InvoicePageFilter from "./InvoicePageFilter";
import Papa from "papaparse";   // ← Added for better CSV export
import StatusBadge from "../../generals/StatusBadge";

function InvoicePage() {
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  
  const { pathname } = useLocation();
  const navigate = useNavigate();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);

  const setInvoiceData = SetInvoiceData();
  const getInvoiceData = GetInvoiceData();
  
  const [tableDataCol, setTableDataCol] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => { isMounted.current = false; };
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('reloadPage') === 'true') {
      sessionStorage.removeItem('reloadPage');
      loadInvoiceData();
    }
  }, []);

  useEffect(() => {
    if (getInvoiceData?.invoice_info?.length) {
      setTableData(getInvoiceData?.invoice_info);
    }
  }, [getInvoiceData?.invoice_info]);

  const numberOrString = (type, value) => {
    if (type === 2) return value;
    return value;
  };

  useEffect(() => {
    document.title = "Invoice Page";
    let tempCol = [];
    getInvoiceData?.display_column?.forEach((menu) => {
      if (menu?.Display_Id === 1) {
        const columnKey = menu?.Column_Value;
        const valueType = menu?.Column_Value_Type_Id;
        tempCol.push({
          title: menu?.Column_Name,
          dataIndex: columnKey,
          sorter: (a, b) => (a?.Created_User_Full_Name ?? '').localeCompare(b?.Created_User_Full_Name ?? ''),
          render:
            columnKey === "Invoice_Status_Name"
              ? (record, row) => (
                  <StatusBadge statusId={row?.Invoice_Status_Id} statusName={record} />
                )
              : (record) => <span>{numberOrString(valueType, record)}</span>,
        });
      }
    });
    setTableDataCol(tempCol.sort((a, b) => b.Print_Sequence - a.Print_Sequence));
  }, [getInvoiceData?.display_column]);

  const loadInvoiceData = async () => {
    try {
      const response = await invoiceService.getInvoiceData();
      if (response?.data !== undefined && isMounted.current) {
        setInvoiceData(response?.data);
      }
    } catch (error) {
      if (isMounted.current) {
        logicContext.showToast("connection error getting invoice data", "error");
      }
    }
  };

  const onFilterAction = (action) => {
    const option = action.target.value;
    if (option === 1) {
      return setTableData(getInvoiceData?.invoice_info);
    }
    const newList = getInvoiceData?.invoice_info.filter(
      (item) => item.Invoice_Status_Id === option
    );
    setTableData(newList);
  };

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }

  async function bulkActions(action) {
    await myPromiseModal({
      title: "confirm your action!",
      body: `Do you want to ${action.Action_Name} ?`,
      showInput: false,
      placeHolder: "",
    }).then((result) => {
      if (result.decision === true) {
        let temp = "";
        const option = action.Procedure_Option;
        itemSelected.map((item) => {
          temp += `<a> <refno> ${item.Invoice_Ref_No} </refno> </a>`;
        });

        let xml_string_refno = `<root> ${temp} </root>`;
        invoiceService.invoiceBulkAction({ xml_string_refno, option }).then((res) => {
          if (res?.data !== undefined && isMounted.current) {
            const { message_text } = res.data[0];
            logicContext.showToast(message_text, "success");
            return loadInvoiceData();
          }
        }).catch((err) => {
          if (isMounted.current) logicContext.showToast("Error", "error");
        });
      }
    });
  }

  function addNewInvoice() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-invoice`);
  }

  const searchByDate = async () => {
    const formData = getValues();
    const response = await invoiceService.getInvoiceByDate(formData);
    if (isMounted.current) {
      if (response?.data?.length) {
        setTableData(response?.data);
      } else {
        logicContext.showToast("No result found", "");
        setTableData([]);
      }
    }
  };

  // ====================== BETTER CSV EXPORT ======================
  const exportToCSV = () => {
    if (!tableData?.length) {
      logicContext.showToast("No data to export", "warning");
      return;
    }
    if (!tableDataCol?.length) {
      logicContext.showToast("No columns defined for export", "warning");
      return;
    }

    const headers = tableDataCol.map(col => col.title);
    const keys = tableDataCol.map(col => col.dataIndex);

    const dataForExport = tableData.map(row => {
      const obj = {};
      keys.forEach((key, i) => {
        let value = row[key] ?? '';
        // Keep numbers as they are (Excel will handle them correctly)
        obj[headers[i]] = value;
      });
      return obj;
    });

    const csv = Papa.unparse(dataForExport, {
      header: true,
      delimiter: ",",
      quoteChar: '"',
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoices_${moment().format("YYYY-MM-DD_HHmmss")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    logicContext.showToast("✅ CSV exported successfully!", "success");
  };
  // ==============================================================

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableData.length,
  };

  function handleRowClick(invoice) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${invoice?.Invoice_Ref_No}`
    );
  }

  const handleCheckboxChange = (option, actionNUmber) => {
    var temp = getInvoiceData?.display_column?.map((item) => {
      if (item.Ref_No === option.Ref_No) {
        return { ...item, Display_Id: actionNUmber };
      }
      return item;
    });
    temp.sort((a, b) => b.Print_Sequence - a.Print_Sequence);
    setInvoiceData({ ...getInvoiceData, display_column: temp });
  };

  function saveCurrentTableHeader() {
    var xmlString = "";
    getInvoiceData?.display_column?.map((element) => {
      if (element.Display_Id === 1) {
        xmlString += `<a><refno>${element.Ref_No} </refno></a>`;
      }
    });
    invoiceService.saveTableHeader({ xml_string: `<root> ${xmlString} </root>`, option: 1 })
      .then(() => {})
      .catch(() => {});
  }

  return (
    <>
      <section>
        <section className="mt-8 md:flex items-center justify-between space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2">
            {itemSelected.length > 0 ? (
              <div className="row">
                <div className="col col-md-4">
                  <Dropdown>
                    <Dropdown.Toggle
                      style={{
                        backgroundColor: "#E5E5E5",
                        border: "none",
                        color: "#45444B",
                        fontSize: "12px",
                        height: "45px",
                      }}
                      id="dropdown-basic"
                    >
                      Bulk Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {getInvoiceData?.bulk_action?.map((action, i) => (
                        <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                          {action.Action_Name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ) : (
              <InvoicePageFilter
                bulkActionData={getInvoiceData?.filtering_criteria}
                onFilterAction={onFilterAction}
              />
            )}

            <Tooltip title="Reload">
              <div
                onClick={() => loadInvoiceData()}
                className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
              >
                <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
              </div>
            </Tooltip>
          </div>

          {/* date search */}
          <div className="grid grid-cols-3 gap-2">
            <div>
              <span className="text-sm">From Date:</span>
              <input
                defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                {...register("from_date")}
                className="bg-filterInput w-full pl-3 rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>
            <div>
              <span className="text-sm">To Date:</span>
              <input
                {...register("to_date")}
                defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                className="bg-filterInput w-full pl-3 rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>
            <div>
              <button
                onClick={searchByDate}
                type="button"
                style={{ backgroundColor: "#476EF8" }}
                className="text-sm text-white px-3 mt-4 rounded py-2.5"
              >
                Search
              </button>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={exportToCSV}
              className="font-[Poppins] font-semibold py-2 px-3 rounded text-sm border border-gray-300 hover:bg-gray-100 active:bg-gray-200 transition-colors"
            >
              EXPORT CSV
            </button>

            <button
              onClick={addNewInvoice}
              className="bg-buttonColor font-[Poppins] font-semibold py-2 px-3 rounded text-white text-sm"
            >
              ADD NEW
            </button>
          </div>
        </section>

        <div className="m-2">
          <TableMenuCheckSelect
            displayCol={getInvoiceData?.display_column}
            handleCheckboxChange={handleCheckboxChange}
            saveCurrentTableHeader={saveCurrentTableHeader}
          />
        </div>

        <section className="mt-5">
          <GeneralCustomTable
            tableHeadList={tableDataCol}
            tableDataList={tableData}
            allowCheckBox={true}
            setSelectedRows={selectedTableItems}
            paginationOptions={paginationOptions}
            rowKey={(record) => record.Invoice_Ref_No}
            handleRowClick={handleRowClick}
          />
        </section>
      </section>
    </>
  );
}

export default InvoicePage;